import { assertNever } from 'app/utils/types';
import { formatOrdinals } from 'app/i18n/utils';

import {
  CS2_ROUNDS_CONFIG,
  CSGO_ROUNDS_CONFIG,
  CS_VIDEOGAME_TITLES,
  EBATTLE_SLUGS,
  EBATTLE_SUBDIVISION_COUNTS,
  VALORANT_ROUNDS_CONFIG,
  VIDEOGAMES_WITH_CUSTOM_MAPS,
  VIDEOGAMES_WITH_STATS,
  VIDEOGAME_WITH_ROUNDS
} from './videogameSpecific.config';

const getRoundConfig = (variation: 'cs-2' | 'cs-go' | 'valorant'): RoundsConfig => {
  switch (variation) {
    case 'cs-2':
      return CS2_ROUNDS_CONFIG;
    case 'cs-go':
      return CSGO_ROUNDS_CONFIG;
    case 'valorant':
      return VALORANT_ROUNDS_CONFIG;
    default:
      throw assertNever(variation);
  }
};

const hasDetailedStats = (videogame: VideogameSlug): boolean =>
  VIDEOGAMES_WITH_STATS.includes(videogame);

const isVideogameWithRounds = (videogame: VideogameSlug): videogame is RoundTypeVideogames =>
  VIDEOGAME_WITH_ROUNDS.includes(videogame as RoundTypeVideogames);

const getStaticMapImage = (videogame: VideogameSlug): string | null =>
  VIDEOGAMES_WITH_CUSTOM_MAPS[videogame] ?? null;

const getVideogameTitle = (videogame_title: BaseTournament['videogame_title']) =>
  videogame_title ? CS_VIDEOGAME_TITLES[videogame_title.name] ?? 'cs-go' : null;

const isEbattle = (slug: VideogameSlug): slug is EBattleSlug =>
  EBATTLE_SLUGS.includes(slug as EBattleSlug);

const getEBattleSubdivisionLabels = (slug: EBattleSlug, lang: string): string[] => {
  const count = EBATTLE_SUBDIVISION_COUNTS[slug];
  return Array.from({ length: count }, (_, i) => formatOrdinals(lang, i + 1).toUpperCase());
};

export {
  getRoundConfig,
  hasDetailedStats,
  isVideogameWithRounds,
  getStaticMapImage,
  getVideogameTitle,
  isEbattle,
  getEBattleSubdivisionLabels
};
